import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import AddEditWardWidget from '../Wards/AddEditWardWidget';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';

interface ViewUsersPageProps extends IAppPropsWithRoute {
};

function AddEditWardPage(props: ViewUsersPageProps): JSX.Element {
    const dispatch = useDispatch();
    //const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])

    const wardId = props.match.params.wardId;

    return (
        <React.Fragment>
            <AddEditWardWidget wardId={wardId} />
        </React.Fragment>
    );
}

export default React.memo(withRouter(AddEditWardPage));